
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.252","height":"15.252","viewBox":"0 0 15.252 15.252"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"linked in","d":"M3.414 15.252V5.069H.252v10.183zM1.831 3.68a1.847 1.847 0 001.831-1.849A1.832 1.832 0 001.831 0 1.832 1.832 0 000 1.832 1.846 1.846 0 001.831 3.68zm13.418 11.572V9.658c0-2.737-.588-4.845-3.788-4.845a3.323 3.323 0 00-2.992 1.644h-.044V5.068H5.392v10.184h3.159V10.21c0-1.328.252-2.611 1.9-2.611 1.62 0 1.644 1.515 1.644 2.7v4.957z","fill":"#fff"}})])
          )
        }
      }
    